import { t } from 'i18next';
import { BaseController, BaseState } from '../../../common/controllers/BaseController';
import { ProfileType } from '../../../common/enums/ProfileType';
import { AuthorizationError } from '../../../common/errors/errors';
import { WithRouterProps, withRouter } from '../../../common/higher-order-components/with-router';
import { UrlHelper } from '../../../common/utils/UrlHelper';
import { PATHS } from '../../../routing/routes';
import { FuzzerProfile } from '../models/FuzzerProfile';
import { TracerProfile } from '../models/TracerProfile';
import { OrganizationProfilesService } from '../services/OrganizationProfilesService';
import { FuzzerController } from './FuzzerController';
import { TracerController } from './TracerController';

type Props = WithRouterProps & {};

type State = BaseState & {};

class Controller extends BaseController<Props, State> {
  private readonly profilesService = new OrganizationProfilesService();

  private profileType: ProfileType;

  constructor(props: Props, context: unknown) {
    super(props, context);

    // Default to TRACER if the query param is not provided or is invalid
    this.profileType = UrlHelper.getQueryParam('profile_type') === 'fuzzer' ? ProfileType.FUZZER : ProfileType.TRACER;
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    this.profilesService.cancelAllRequests();
  }

  protected shouldCheckPermissionToAccess(): boolean {
    return true;
  }

  protected async checkPermissionToAccess(): Promise<void> {
    const canCreateProfile = await this.permissionsService.canCreateProfile();
    if (!canCreateProfile) {
      throw new AuthorizationError(PATHS.PROFILES);
    }
  }

  render() {
    return this.renderBase(
      <>
        {this.profileType === ProfileType.TRACER && (
          <TracerController
            profile={TracerProfile.blank()}
            editable={true}
            breadcrumbName={t('createProfile.title', { profileType: t('tracer') })}
            breadcrumbPath={`${PATHS.PROFILES_CREATE}?profile_type=tracer`}
            title={t('createProfile.title', { profileType: t('tracer') })}
          />
        )}
        {this.profileType === ProfileType.FUZZER && (
          <FuzzerController
            profile={FuzzerProfile.blank()}
            isEditable={true}
            breadcrumbName={t('createProfile.title', { profileType: t('fuzzer') })}
            breadcrumbPath={`${PATHS.PROFILES_CREATE}?profile_type=fuzzer`}
            title={t('createProfile.title', { profileType: t('fuzzer') })}
          />
        )}
      </>
    );
  }
}

export const CreateProfileController = withRouter(Controller);
